import { getFromLocalStorage } from "./helpers/localstorage";

function feature(name, prod, test, dev) {
  return {
    get [name]() {
      if (window.config.environment === "dev") {
        if (typeof dev === "boolean") return dev;
        if (typeof test === "boolean") return test;
        return prod;
      }
      if (window.config.environment === "test") {
        if (typeof test === "boolean") return test;
        return prod;
      }
      return prod;
    },
  };
}

const def = {
  ...feature("companyInvestments", true),
  ...feature("collectiveAgreements", false, false),
  ...feature("comments", true),
  ...feature("entityNews", false),
  // the News actions page: the news pipeline only runs for the tenants that turn this on
  ...feature("newsActions", false),
};

const features = {
  default: def,
  france: {
    ...def,
    ...feature("collectiveAgreements", true),
    ...feature("companyInvestments", false, false, false),
    ...feature("entityNews", true),
  },
  italy: {
    ...def,
    ...feature("entityNews", true),
  },
  spain: {
    ...def,
  },
  mexico: {
    ...def,
    ...feature("newsActions", true),
  },
  germany: {
    ...def,
  },
  portugal: {
    ...def,
  },
  uk: {
    ...def,
  },
  us: {
    ...def,
  },
};

export default features;

export function getFeatures() {
  const tenant = getFromLocalStorage("lefacTenant")?.data || "default";
  return features[tenant];
}

window.getFeatures = getFeatures;
